export function hasWebGL2(canvas: HTMLCanvasElement): boolean {
  try {
    return canvas.getContext("webgl2") !== null;
  } catch {
    return false;
  }
}
